import React from 'react';
import VenturiLoader from '../common/VenturiLoader';

export const ScenarioPlannerEmptyState = () => (
    <div className="scenario-planner">
        <div className="empty-state-container">
            <div className="empty-state-content">
                <div className="empty-state-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                        <path d="m7.5 4.27 9 5.15"></path>
                        <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"></path>
                        <path d="m3.3 7 8.7 5 8.7-5"></path>
                        <path d="M12 22V12"></path>
                    </svg>
                </div>
                <h3 className="empty-state-title">Select Products to Get Started</h3>
                <p className="empty-state-message">
                    Choose one or more products from the sidebar to analyze production capacity,
                    plan scenarios, and create production plans.
                </p>
                <div className="empty-state-steps">
                    <div className="step-item">
                        <span className="step-number">1</span>
                        <span className="step-text">Open the sidebar filters</span>
                    </div>
                    <div className="step-item">
                        <span className="step-number">2</span>
                        <span className="step-text">Select products you want to analyze</span>
                    </div>
                    <div className="step-item">
                        <span className="step-number">3</span>
                        <span className="step-text">View capacity and create production plans</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export const ScenarioPlannerLoadingState = () => (
    <div className="scenario-planner">
        <div className="loading-container" style={{ minHeight: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <VenturiLoader 
                message="Loading scenario data..." 
                subMessage="Calculating production capacities and revenue projections..." 
            />
        </div>
    </div>
);
